export const lessonAnalyticsQuestionsMockText = {
  title: 'Lesson 1',
  pickedFirst: 'Picked first:',
  questions: 'Questions',
  branches: 'Branches',
};
